import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useRfmPersonaList } from '@/modules/rfm/persona/model/list';
import { promotionService } from '@/services/promotion';
import { computed } from 'vue';

export function usePromotionPrototypeList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchItemsInPage()
    });

    const { fetchPersonaAll, personaMap } = useRfmPersonaList();

    const {
        fetchList: fetchItemsInPage,
        list: itemsInPage,
        total
    } = useBaseListView({
        request: promotionService.prototype.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            loadInitialData: async () => await fetchPersonaAll(),
            onPageChange: (offset: number) => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: (list: any[]) =>
                list.map((item: any) => {
                    item.personas.forEach((per: any) => {
                        per.rfmPersonaName = personaMap.value.get(per.rfmPersonaId)?.name;
                    });
                    return item;
                })
        }
    });

    const prototypeMap = computed(() => new Map(prototypeAll.value.map((item: any) => [item.id, item])));
    const { fetchList: fetchPrototypeAll, list: prototypeAll } = useBaseListView({
        request: promotionService.prototype.listAll,
        hooks: {
            loadInitialData: async () => await fetchPersonaAll(),
            transformResponse: (list: any[]) =>
                list.map((item: any) => {
                    item.personas.forEach((per: any) => {
                        per.rfmPersonaName = personaMap.value.get(per.rfmPersonaId)?.name;
                    });
                    return item;
                })
        }
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: promotionService.prototype.remove,
            onSuccess: () => fetchItemsInPage()
        })
    };

    return {
        itemsInPage,
        fetchItemsInPage,
        total,
        query,
        actions,
        fetchPrototypeAll,
        prototypeAll,
        prototypeMap
    };
}
